import { Injectable, Injector } from '@angular/core';
import { Adiantamento, BaseResourceService, ContratoAditamento } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContratoAditamentoService extends BaseResourceService<ContratoAditamento> {

  constructor(
    protected injector: Injector
  ) {
    super(`contrato-aditamentos`, injector);
  }

  public proximoNumero(contrato: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/proximo-numero/${contrato}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public salvarLista(aditivo: ContratoAditamento): Observable<ContratoAditamento> {
    return this.http.post(`${this.login.cidade.id}/${this.api}/salvar-lista`, aditivo, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }
}
